"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = require("@coastomizer/component");
var _sizes = require("@coastomizer/sizes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Block = /*#__PURE__*/function (_Coastomizer) {
  _inherits(Block, _Coastomizer);
  var _super = _createSuper(Block);
  function Block(props) {
    var _this;
    _classCallCheck(this, Block);
    _this = _super.call(this, props);
    _this.base = "div";
    if (props.as) {
      _this.base = props.as;
    }
    _this.mapAttributesToRules = {
      marginTop: "customMarginTop",
      marginRight: "customMarginRight",
      marginBottom: "customMarginBottom",
      marginLeft: "customMarginLeft",
      marginHorizontal: "marginHorizontal",
      marginVertical: "marginVertical",
      paddingTop: "customPaddingTop",
      paddingRight: "customPaddingRight",
      paddingBottom: "customPaddingBottom",
      paddingLeft: "customPaddingLeft",
      paddingHorizontal: "paddingHorizontal",
      paddingVertical: "paddingVertical",
      realBlock: "realBlock",
      rtl: "rtl"
    };
    _this.defaultRules = [{
      display: "flex",
      flexDirection: "row"
    }];
    _this.complexRules = {
      realBlock: function realBlock(type) {
        return [{
          display: type === true ? "block" : type
        }];
      },
      rtl: function rtl() {
        return [{
          direction: "rtl"
        }];
      },
      customMarginTop: function customMarginTop(marginTop) {
        return [{
          marginTop: marginTop === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : marginTop
        }];
      },
      customMarginRight: function customMarginRight(marginRight) {
        return [{
          marginRight: marginRight === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : marginRight
        }];
      },
      customMarginBottom: function customMarginBottom(marginBottom) {
        return [{
          marginBottom: marginBottom === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : marginBottom
        }];
      },
      customMarginLeft: function customMarginLeft(marginLeft) {
        return [{
          marginLeft: marginLeft === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : marginLeft
        }];
      },
      marginHorizontal: function marginHorizontal(_marginHorizontal) {
        return [{
          marginRight: _marginHorizontal === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _marginHorizontal,
          marginLeft: _marginHorizontal === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _marginHorizontal
        }];
      },
      marginVertical: function marginVertical(_marginVertical) {
        return [{
          marginTop: _marginVertical === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _marginVertical,
          marginBottom: _marginVertical === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _marginVertical
        }];
      },
      customPaddingTop: function customPaddingTop(paddingTop) {
        return [{
          paddingTop: paddingTop === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : paddingTop
        }];
      },
      customPaddingRight: function customPaddingRight(paddingRight) {
        return [{
          paddingRight: paddingRight === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : paddingRight
        }];
      },
      customPaddingBottom: function customPaddingBottom(paddingBottom) {
        return [{
          paddingBottom: paddingBottom === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : paddingBottom
        }];
      },
      customPaddingLeft: function customPaddingLeft(paddingLeft) {
        return [{
          paddingLeft: paddingLeft === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : paddingLeft
        }];
      },
      paddingHorizontal: function paddingHorizontal(_paddingHorizontal) {
        return [{
          paddingRight: _paddingHorizontal === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _paddingHorizontal,
          paddingLeft: _paddingHorizontal === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _paddingHorizontal
        }];
      },
      paddingVertical: function paddingVertical(_paddingVertical) {
        return [{
          paddingTop: _paddingVertical === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _paddingVertical,
          paddingBottom: _paddingVertical === true ? (0, _sizes.pixular)(_sizes.genericSizeConstants.md) : _paddingVertical
        }];
      }
    };
    return _this;
  }
  return _createClass(Block);
}(_component.Coastomizer);
Block.propTypes = {
  rtl: _propTypes["default"].bool,
  realBlock: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  marginTop: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  marginRight: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  marginBottom: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  marginLeft: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  marginHorizontal: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  marginVertical: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  paddingHorizontal: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  paddingVertical: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  customStyle: _propTypes["default"].arrayOf(_propTypes["default"].object),
  innerRef: _propTypes["default"].any
};
var _default = Block;
exports["default"] = _default;